import { computed, toValue } from 'vue';
import { useSportLiveTvOverview } from '@/sport-live-tv/composables/use-sport-live-tv-overview';

export const useSportLiveTvEvent = (eventId) => {
  const { categories, popular, isLoading, isError, refetch } = useSportLiveTvOverview();

  const event = computed(() => {
    const categoryEvents = categories.value.flatMap(({ events }) => events);

    return [...popular.value, ...categoryEvents].find(({ id }) => id === toValue(eventId));
  });

  const isEventError = computed(() => isError.value || (!isLoading.value && !event.value));

  return { event, isLoading, isError: isEventError, refetch };
};
